module.exports = __webpack_public_path__ + "img/Prolight.30312ad8.png";